module.exports = __webpack_public_path__ + "img/task.78743c47.png";